export const lightgray = '#F7F9FC';
export const lightBlue = '#4D76AC';
export const darkBlue = '#2C3B5A';
export const yellow = '#F5C83A';
export const white = '#ffffff';
export const black = '#000000';
export const gray = '#dadada';
export const red = '#ba000d';
export const errorRed = '#ED1C29';
export const optionErrorBoxBg = '#E1F8FE';
